import PostCard from './PostCard'
import { colors } from '../../colors'
import { BargainUserInfo, Post } from '../../types'

interface PostListProps {
  posts: Post[]
  bargain_user_info: BargainUserInfo
  onPostDelete?: (postId: number) => void
  onReactionChange?: () => void
  emptyMessage?: string
  className?: string
  style?: React.CSSProperties
}

const styles: Record<string, React.CSSProperties> = {
  postList: {
    maxWidth: '800px',
  },
  postsContainer: {
    display: 'flex',
    gap: '4px',
    padding: '0 8px',
  },
  column: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  noPosts: {
    textAlign: 'center',
    padding: '20px',
    color: colors['text-secondary'],
  },
}

const PostList: React.FC<PostListProps> = ({
  posts,
  bargain_user_info,
  onPostDelete,
  onReactionChange,
  emptyMessage = 'まだ投稿はありません。',
  className,
  style,
}) => {
  if (posts.length === 0) {
    return (
      <div style={styles.noPosts} className={className}>
        {emptyMessage}
      </div>
    )
  }

  // 各投稿の推定高さを計算（アスペクト比ベース）
  const getEstimatedHeight = (post: Post): number => {
    const hasImages = post.images && post.images.length > 0
    if (!hasImages) {
      return 1.0 // 正方形（画像なし）
    }
    // 画像ありの場合、PostCardでは0.85を閾値に正方形(1:1)か縦長(3:4)を判定する
    // ここでは実際の画像アスペクト比が不明なため、正方形(1.0)と縦長(1.33)の中間値で推定
    return 1.2 // 経験的な推定値（やや縦長寄り）
  }

  // 累積高さが低い方の列に投稿を追加
  const distributePostsBalanced = () => {
    const leftColumn: Post[] = []
    const rightColumn: Post[] = []
    let leftHeight = 0
    let rightHeight = 0

    posts.forEach((post) => {
      const estimatedHeight = getEstimatedHeight(post)

      if (leftHeight <= rightHeight) {
        leftColumn.push(post)
        leftHeight += estimatedHeight
      } else {
        rightColumn.push(post)
        rightHeight += estimatedHeight
      }
    })

    return { leftColumn, rightColumn }
  }

  const { leftColumn: leftPosts, rightColumn: rightPosts } = distributePostsBalanced()

  return (
    <div style={{ ...styles.postList, ...style }} className={className}>
      <div style={styles.postsContainer}>
        {/* 左列 */}
        <div style={styles.column}>
          {leftPosts.map((post) => (
            <PostCard
              key={post.id}
              post={post}
              bargain_user_info={bargain_user_info}
              onDelete={onPostDelete}
              onReactionChange={onReactionChange}
            />
          ))}
        </div>

        {/* 右列 */}
        <div style={styles.column}>
          {rightPosts.map((post) => (
            <PostCard
              key={post.id}
              post={post}
              bargain_user_info={bargain_user_info}
              onDelete={onPostDelete}
              onReactionChange={onReactionChange}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default PostList
